import * as Constants from '../constants/table';

const initialState = {
  tableInfo: {
    url: null,
    key: null,
    filters: null,
    sort_options: null,
    search_term: null,
    page_size: 15,
  },
  detailUrl: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.SET_TABLE_DATA_INFO:
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          ...action.payload,
        },
      };
    case Constants.SET_TABLE_DETAIL_URL:
      return {
        ...state,
        detailUrl: action.payload,
      };
    default:
      return state;
  }
};
